import React, { useMemo } from 'react';
import { Grid } from '@mui/material';
import PropTypes from 'prop-types';
import { withBaseEditor, CommandPanels } from '../../BaseEditor';

function BudgetaryInstitutionsEditor({
  getControl,
}) {
  const payerFilter = useMemo(
    () => ({ is_landlord: true }),
    [],
  );
  return (
    <Grid container spacing={2}>
      <Grid item sm={12}>
        {getControl('payer', { filter: payerFilter })}
      </Grid>
    </Grid>
  );
}

BudgetaryInstitutionsEditor.propTypes = {
  getControl: PropTypes.func.isRequired,
  currentUser: PropTypes.shape({
    is_superuser: PropTypes.bool,
  }).isRequired,
};

export default withBaseEditor(BudgetaryInstitutionsEditor, '/api/catalog/budgetaryinstitutions/', CommandPanels.catCommandPanel);
